function reducer(state = [], action) {
    switch (action.type) {
        case 'BALANCE/SET':
            return action.balance;
        default:
            return state;
    }
}

export default reducer;
